module.exports = __webpack_public_path__ + "static/media/pool-light.18fe9822.svg";